(() => {
  const styleId = 'mm-payment-terms-font';

  const applyFont = (paymentTerms) => {
    const shadowRoot = paymentTerms.shadowRoot;

    if (!shadowRoot || shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '.font-sans { font-family: var(--font-body-family) !important; }';
    shadowRoot.append(style);
  };

  const applyFonts = () => {
    document.querySelectorAll('shopify-payment-terms').forEach(applyFont);
  };

  let scheduled = false;
  const scheduleApplyFonts = () => {
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyFonts();
    });
  };

  const observePaymentTerms = () => {
    applyFonts();

    customElements.whenDefined('shopify-payment-terms').then(applyFonts);

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    new MutationObserver(scheduleApplyFonts).observe(productInfo, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePaymentTerms, { once: true });
  } else {
    observePaymentTerms();
  }
})();
